import { css } from 'styled-components';
import { setRgbaAlpha } from './color-utils';
import { base800 } from '@prisjakt/design-tokens/light-theme-colors.json';

/**
 * An overlay helper that can be included within a pseudo-element like ::before or ::after, in
 * order to cover the whole area of the nearest positioning context with the specified color.
 *
 * Can be used instead of a background-color in order to avoid white boxes around e.g. product
 * images, which generally have a white background.
 */
export const overlay = (color?: string) => css`
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${color || setRgbaAlpha(base800, 0.04)};
  z-index: 1;
`;
